var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.sqlStatement ? 'handpointer' : '',on:{"click":function($event){$event.stopPropagation();return _vm.copyToClipboard($event)}}},[_vm._v("\n    ("+_vm._s(_vm.timeFormatted)+" s)\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d354e98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SqlDetails.vue
// module id = null
// module chunks = 